// extracted by mini-css-extract-plugin
export default {"modify_order_header":"Iu","center":"Ju","empty":"Ku","pending":"Lu","referralTitle":"Mu","wrapper":"Nu","title":"Ou","tabs":"Pu","tab":"Qu","active":"Ru","btn":"Su","rewards_table":"Tu"};
    if(module.hot) {
      // 1713969926301
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  